import { Container, Text } from 'pixi.js';
import { type SpeechBubbleConfig, SpeechBubbleView } from './SpeechBubbleView';

interface TextBubbleViewConfig {
  text: string;
  pointer: SpeechBubbleConfig['pointer'];
  padding?: number;
}

export class TextBubbleView extends Container {
  constructor(config: TextBubbleViewConfig) {
    super();

    const { pointer, text, padding = 20 } = config;

    const displayObject = new Text(text, {
      fontFamily: 'Baloo',
      fill: '#5A1A18',
      wordWrap: true,
      wordWrapWidth: 320,
      fontSize: 30,
      align: 'center',
      lineHeight: 26,
    }).props({
      anchor: 0.5,
    });

    const speechBubble = new SpeechBubbleView({
      pointer,
      body: { width: displayObject.width + padding, height: displayObject.height + padding },
    }).props({
      parent: this,
    });

    displayObject.props({
      parent: speechBubble.getContentContainer(),
    });
  }
}
